import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';

export function EmailPreview({ campaignId, draft }) {
  const [p, setP] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const t = setTimeout(() => {
      api.post(`/campaigns/${campaignId}/preview`, { draft })
        .then(({ data }) => { setP(data); setError(''); })
        .catch(() => { setP(null); setError('Completa los campos obligatorios para ver la vista previa.'); });
    }, 500);
    return () => clearTimeout(t);
  }, [campaignId, draft]);

  return (
    <Card className="p-4 space-y-3 lg:sticky lg:top-20" data-testid="email-preview">
      <div className="text-xs uppercase tracking-wider text-[hsl(var(--muted-foreground))]">Vista previa</div>
      {p && (
        <>
          <div className="text-sm"><span className="text-[hsl(var(--muted-foreground))]">Para:</span> {p.contact?.pastor} · {p.contact?.email}</div>
          <div className="text-sm font-semibold" data-testid="email-preview-subject">{p.subject}</div>
          <iframe title="Vista previa del correo" srcDoc={p.html} sandbox="" className="w-full h-[640px] rounded-md bg-white" data-testid="email-preview-frame" />
        </>
      )}
      {error && <div className="text-xs text-amber-300">{error}</div>}
    </Card>
  );
}
